export const BRANCH_SEQUENCE_TOKENS = [
    "RDC Branch",
    "NDC Branch",
    "Buddy Branches",
];

export const DAY_OPTIONS = [
    { label: "Mon", value: 1 },
    { label: "Tue", value: 2 },
    { label: "Wed", value: 3 },
    { label: "Thu", value: 4 },
    { label: "Fri", value: 5 },
    { label: "Sat", value: 6 },
    { label: "Sun", value: 7 },
];

export const DAY_VALUES = DAY_OPTIONS.map((day) => day.value);

const DAY_LABELS_BY_VALUE = DAY_OPTIONS.reduce((labels, day) => {
    labels[day.value] = day.label;
    return labels;
}, {});

export const formatDaysOfWeek = (daysOfWeek) => {
    if (!Array.isArray(daysOfWeek)) {
        return daysOfWeek ?? "";
    }

    return daysOfWeek
        .map((day) => DAY_LABELS_BY_VALUE[day] ?? day)
        .join(", ");
};

export const createEmptySequence = () => ({
    timeRangeStart: "",
    timeRangeEnd: "",
    daysOfWeek: [],
    branchSequence: [],
});
